var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconCapture = function SvgIconCapture(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "16px",
    viewBox: "0 0 20 16",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "67CFB71F-C456-4668-8A1F-9D668E60D66C")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Feed",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "comment-icons",
    transform: "translate(-96.000000, -21.000000)",
    stroke: "#90949C"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-capture",
    transform: "translate(97.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5497933,14.0307692 C17.3507195,14.0307692 18,13.3452392 18,12.4995972 L18,3.80423025 C18,2.95858115 17.3507146,2.27304735 16.5497818,2.27304399 L14.417015,2.27304399 C13.6676991,2.27303995 13.0196666,1.72169769 12.8603443,0.948637599 C12.7462387,0.39491117 12.2820684,0 11.7453523,0 L6.25463616,0 C5.71792261,0 5.25375635,0.394915452 5.13964416,0.948637599 C4.98032761,1.72170229 4.33229049,2.27304782 3.58297152,2.27304399 L1.45020672,2.27304399 C1.0655875,2.27304345 0.696721155,2.43436301 0.424754473,2.72151403 C0.152787791,3.00866505 0,3.39812549 0,3.80421808 L0,12.499585 C0,12.9056811 0.152787048,13.2951454 0.424756276,13.5822987 C0.696725505,13.869452 1.06559567,14.0307692 1.45021824,14.0307692 L16.5497933,14.0307692 Z",
    id: "icom-add-photo",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99995265,4.37315234 C10.3103917,4.37315234 11.4917964,5.16492837 11.9932791,6.37926748 C12.4947619,7.59360659 12.2175643,8.99137101 11.2909431,9.92078494 C10.364322,10.8501989 8.97075964,11.12823 7.76007249,10.6252328 C6.54938535,10.1222355 5.76,8.93726668 5.76,7.62287574 C5.76199837,5.82893397 7.21140462,4.37515673 8.99995265,4.37315234 L8.99995265,4.37315234 Z",
    id: "Path"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCapture, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-capture.81beac34.svg";
export { ForwardRef as ReactComponent };